<template>
  <div class="case_box">
    <el-select v-model="form.type" placeholder="请选择" @change="Change()">
      <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id"></el-option>
    </el-select>
    <el-button type="success" @click="addCase()">新增一个案例</el-button>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="name" label="案例名称" width="200">
      </el-table-column>
      <el-table-column prop="intro" label="安全介绍">
      </el-table-column>
      <el-table-column width="300" label="操作">
        <template slot-scope="scope">
          <el-button type="warning" size="small" @click="Modify(scope.row)">修改</el-button>
          <el-button type="danger" size="small" @click="Del(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="block">
      <el-pagination @current-change="handleSizeChange" :current-page="currentPage1" background :page-size="pageSize"
        layout="total, prev, pager, next,jumper" :total="total"></el-pagination>
    </div>
  </div>
</template>

<script>
  import {
    instanceList,
    instanceDel
  } from '../api/api'
  import local from '../utils/local'

  export default {
    data() {
      return {
        options: [{
            name: '猪',
            id: 1
          },
          {
            name: '牛',
            id: 2
          },
          {
            name: '羊',
            id: 3
          },
          {
            name: '鸡',
            id: 4
          }
        ],
        tableData: [],
        form: {
          type: ""
        },
        currentPage1: 1,
        pageSize: 30,
        total: 0,
        admin_id: local.get('admin_id')
      }
    },
    methods: {
      handleSizeChange(val) {
        this.currentPage1 = val;
        this.getInfo()
      },
      addCase() {
        this.$router.push('/home/caseDetails')
      },
      Del(id) {
        this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          instanceDel(this.admin_id, id).then(res => {
            if (res.data.status == 200) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.getInfo()
            } else {
              this.$message.error(res.data.msg)
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      Change() {
        this.getInfo()
      },
      getInfo() {
        instanceList(this.admin_id, this.form.type, this.currentPage1, this.pageSize).then(res => {
          console.log(res)
          this.tableData = res.data.data.data;
          this.total = res.data.data.total;
        })
      },
      Modify(data) {
        this.$router.push({
          path: `/home/caseDetails`,
          query: {
            data: JSON.stringify(data),
          }
        });
      }
    },
    created() {
      this.getInfo()
    }
  }
</script>

<style lang="less" scoped>
  .case_box {
    padding: 0 50px;
    box-sizing: border-box;
    width: 100%;

    .el-select {
      margin-right: 10px;
    }

    .block {
      display: flex;
      justify-content: center;
      margin-top: 30px;

    }
  }
</style>